<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="mb-2" :title="`${this.$route.query.subject} (${this.$route.query.ownerName})`">
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-button
          class="mr-3 mb-2"
          @click="$router.back()"
          type="flat"
          icon-pack="feather"
          icon="icon-chevron-right"
        >بازگشت</vs-button>
      </div>
    </div>
    <div id="component-chat-log" class="m-8" v-if="items">
      <div v-for="(msg, index) in items" class="msg-grp-container" :key="index">
        <template v-if="items[index-1]">
          <!-- seperator between two days -->
          <vs-divider
            v-if="!isSameDay(msg.submiteDate, items[index-1].submiteDate)"
            class="msg-time"
          >
            <span>{{$moment(msg.submiteDate).format('jYYYY/jM/jD') }}</span>
          </vs-divider>

          <!-- seperator between two sender -->
          <div
            class="spacer mt-8"
            v-if="!hasSentPreviousMsg(items[index-1].isOperator, msg.isOperator)"
          ></div>
        </template>

        <div class="flex items-start" :class="[{'flex-row-reverse' : msg.isOperator}]">
          <!-- avatar -->
          <template
            v-if="index == 0 || !hasSentPreviousMsg(items[index-1].isOperator, msg.isOperator) || !isSameDay(msg.submiteDate, items[index-1].submiteDate)"
          >
            <vs-avatar
              size="40px"
              class="border-2 shadow border-solid border-white m-0 flex-shrink-0"
              :class="msg.isOperator ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
              :src="senderImg(msg.isOperator)"
            ></vs-avatar>
          </template>

          <template v-if="items[index-1]">
            <div
              class="mr-16"
              v-if="!(!hasSentPreviousMsg(items[index-1].isOperator, msg.isOperator) || !isSameDay(msg.submiteDate, items[index-1].submiteDate))"
            ></div>
          </template>

          <div
            class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm"
            :class="{'bg-primary-gradient text-white': msg.isOperator, 'border border-solid border-grey-light bg-white': !msg.isOperator}"
          >
            <span>{{ msg.message }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="chat__input flex p-4 bg-white" style="align-items: flex-end;">
      <vs-textarea
        class="flex-1 mb-0"
        placeholder="پیام خود را اینجا بنویسید!"
        v-model="typedMessage"
        @keyup.enter="sendMsg"
      />
      <vs-button class="bg-primary-gradient ml-4" type="filled" @click="sendMsg">ارسال</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      typedMessage: ""
    };
  },
  computed: {
    hasSentPreviousMsg() {
      return (last_sender, current_sender) => last_sender == current_sender;
    }
  },
  methods: {
    senderImg() {},
    fillTable() {
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          ticketId: this.$route.query.id
        }
      }; //
      this.$http
        .post("/api/services/app/Support/ReadTicket", payload)
        .then(response => {
          this.items = response.data.result;
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    sendMsg() {
      let loading = this.$vs.loading();

      let payload = {
        ticketId: this.$route.query.id,
        message: this.typedMessage
      };
      this.$http
        .post("/api/services/app/TicketItems/CreateOrEdit", payload)
        .then(response => {
          if (response.data.success == true) {
            this.fillTable();
            this.typedMessage = "";
            this.$emit("success");
          }
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
    isSameDay(time_to, time_from) {
      const date_time_to = new Date(Date.parse(time_to));
      const date_time_from = new Date(Date.parse(time_from));
      return (
        date_time_to.getFullYear() === date_time_from.getFullYear() &&
        date_time_to.getMonth() === date_time_from.getMonth() &&
        date_time_to.getDate() === date_time_from.getDate()
      );
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight;
      });
    }
  },
  updated() {
    this.scrollToBottom();
  },
  mounted() {
    this.fillTable();
    this.scrollToBottom();
  }
};
</script>
